import React from "react";
import {
  KeyValuePairs,
  Modal,
  Button,
  SpaceBetween,
} from "@amzn/awsui-components-react";
import {
  OmsRecordFilter,
  OmsReport,
} from "../../lusca-search-api/generated-src";
import useOmsModalHeight from "../../hooks/useOmsModalHeight";
import { reportTimestamp } from "./OMSReportSchedule";
import OMSSettingsSummary from "./OMSSettingsSummary";
import OMSWorkflow, { OMSWorkflowSection } from "./OMSWorkflow";

export default function OMSExportReview({
  productLabel,
  report,
  mode,
  filters,
  operation,
  columns,
  allColumns,
  onBack,
  actions,
  page = false,
}: {
  productLabel: string;
  report: OmsReport;
  mode: "full" | "filtered";
  filters: OmsRecordFilter[];
  operation: "and" | "or";
  columns: string[];
  allColumns: boolean;
  onBack: () => void;
  actions: React.ReactNode;
  page?: boolean;
}) {
  const { height, width, contentRef, titleRef, footerRef } =
    useOmsModalHeight(840);
  const Wrapper = page ? OMSWorkflow : Modal;
  return (
    <Wrapper
      heading="Review export settings"
      focusHeading
      stage="review"
      visible
      header={<span ref={titleRef}>Review export settings</span>}
      width={width}
      size="x-large"
      height={height}
      position="top"
      onDismiss={onBack}
      closeAriaLabel="Back to export settings"
      footer={
        <div ref={footerRef} className="oms-report-download__footer">
          <Button onClick={onBack}>Back to settings</Button>
          {actions}
        </div>
      }
    >
      <div ref={contentRef}>
        <SpaceBetween size="l">
          <OMSWorkflowSection title="Report">
            <KeyValuePairs
              columns={2}
              items={[
                { label: "Product", value: productLabel },
                {
                  label: "Pinned report refreshed",
                  value: (
                    <time dateTime={report.sourceRefreshedAt}>
                      {reportTimestamp(report.sourceRefreshedAt)}
                    </time>
                  ),
                },
              ]}
            />
          </OMSWorkflowSection>
          <OMSSettingsSummary
            report={report}
            mode={mode}
            filters={filters}
            operation={operation}
            columns={columns}
            allColumns={allColumns}
            standalone
            grouped={page}
          />
        </SpaceBetween>
      </div>
    </Wrapper>
  );
}
